import { render } from "./Site-add.vue?vue&type=template&id=540be89d"
import script from "./Site-add.vue?vue&type=script&lang=js"
export * from "./Site-add.vue?vue&type=script&lang=js"

import "./Site-add.vue?vue&type=style&index=0&id=540be89d&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__